

























































import { Component, Prop, Watch, Vue, Mixins } from 'vue-property-decorator'
import { Debounce } from 'vue-debounce-decorator'
import PenCanvas from '@/components/modules/drills/atoms/PenCanvas.vue'
import ImageMixin from '@/components/modules/drillsv3/molecules/ImageMixin'
import TooltipButton from '@/components/modules/drills/atoms/TooltipButton.vue'
import _ from 'lodash'
import DrillWebApi from '@/mixins/drillsv3/WebApi'

@Component({
  components: {
    PenCanvas,
    TooltipButton,
  },
})
export default class ImageVertical extends Mixins(ImageMixin, DrillWebApi) {
  // 読み込み完了フラグ
  private loadComplete = false

  @Prop({ default: 0 })
  pageIndex!: number

  @Prop({ default: 1 })
  pageNum!: number

  private canvasNameRight = 'canvasRight'
  private canvasNameLeft = 'canvasLeft'

  private handleResize = _.throttle(this.changeCanvasSize, 500)

  // s3アクセス用フルURL
  private dokkaiUrl: string[] = []
  private mondaiUrl: string[] = []
  private sijiUrl: string | null = null

  private get hasDokkai(): boolean {
    return this.dokkai(this.pageIndex).length > 0
  }

  private async mounted() {
    Vue.prototype.$loading.startWhite()
    // s3アクセス用URL取得
    this.dokkaiUrl = await Promise.all(
      this.dokkai(this.pageIndex).map(async (path) => {
        return await this.getImageUrl(path)
      })
    )
    this.mondaiUrl = await Promise.all(
      this.mondai(this.pageIndex).map(async (path) => {
        return await this.getImageUrl(path)
      })
    )
    const siji = this.siji(this.pageIndex)
    if (siji) {
      this.sijiUrl = await this.getImageUrl(siji)
    }

    window.addEventListener('resize', this.handleResize)
    this.loadComplete = true
    Vue.prototype.$loading.complete()
  }

  /**
   * ページ番号を算出して返す
   */
  private get pageNumber(): number {
    return this.currentPageNumber || this.pageNum
  }

  private beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }

  @Watch('processed')
  onProcessedChanged(newValue: boolean, oldValue: boolean) {
    Vue.prototype.$logger.info('-- onProcessedChanged')

    if (newValue) {
      const leftBlock = this.$refs['left-block'] as HTMLElement
      const rightBlock = this.$refs['right-block'] as HTMLElement
      // 読解文エリア、問題文エリアのスクロールを一番右にする
      this.$nextTick()
      leftBlock?.scrollTo(Number.MAX_SAFE_INTEGER, 0)
      rightBlock?.scrollTo(Number.MAX_SAFE_INTEGER, 0)
    }
  }

  @Debounce(300)
  private changeCanvasSize(): void {
    const leftBlock = this.$refs['left-block'] as HTMLElement
    const rightBlock = this.$refs['right-block'] as HTMLElement

    // canvasサイズ設定
    this.setCanvasSize(Vue.prototype.$penCanvases[this.canvasNameLeft], this.calculateCanvasSize(leftBlock))
    this.setCanvasSize(Vue.prototype.$penCanvases[this.canvasNameRight], this.calculateCanvasSize(rightBlock))
  }

  private calculateCanvasSize(element: HTMLElement): any {
    if (!element) return { width: 0, height: 0 }

    const imgs = Array.prototype.slice.call(element.getElementsByTagName('img'))
    const titles = Array.prototype.slice.call(element.getElementsByClassName('image__title'))
    let [width, height] = [0, 0]
    imgs.forEach((e: HTMLElement) => {
      // padding分 10px足しておく
      width += e.clientWidth + 10
      height = e.clientHeight
    })
    titles.forEach((e: HTMLElement) => {
      // margin分 30px足しておく
      width += e.clientWidth + 30
    })
    return { width, height }
  }

  private setCanvasSize(canvas: any, size: { width: number; height: number }): void {
    if (!canvas) return

    canvas.changeSize({
      width: size.width,
      height: size.height,
    })
    canvas.setCanvasContext()
  }
}
